import { Dispatch } from "../../config/controller";
import { ConfigPainelChamada } from "../../config/data.types";
import { Model,StateProps } from "../../config/model";

export type { ConfigPainelChamada } from "../../config/data.types";

export interface ConfigPainelChamadaState extends StateProps<ConfigPainelChamada> {
 
}

export interface ConfigPainelChamadaActions extends Dispatch<ConfigPainelChamada> {

}

const model = new Model<ConfigPainelChamada,ConfigPainelChamadaState>("config_painel_chamada");

export const initialValueConfigPainelChamada: ConfigPainelChamada = {
    ...model.getInitialValue(),
    type:"config_painel_chamada",
    _id:"@config",
    cor_primaria:"",
    cor_secundaria:"",
    descricao:"",
    logo_clinica:"",
    nome_clinica:"",
    play_list:[],
    id_video_youtube:""
    
}

export const initialValueConfigPainelChamadaState: ConfigPainelChamadaState = {
    ...model.getInititalValueState(),
    row:initialValueConfigPainelChamada,   
}


